import { isToday } from '~/src/lib/date';

const getFilteredOrders = (orders, params) => {
    let result = [...orders];

    if (typeof params.status === 'string') {
        if (params.status === 'not_delivered') {
            result = result.filter((o) => [11].includes(o.status_id) === false);
        } else if (params.status === 'paid') {
            result = result.filter((o) => [3, 6].includes(o.payment_status_id));
        } else if (params.status === 'unpaid') {
            result = result.filter((o) => [1, 2].includes(o.payment_status_id));
        }
    }

    if (typeof params.today === 'boolean') {
        result = result.filter((o) => isToday(o.date, 'sql'));
    }

    if (typeof params.type === 'string') {
        if (params.type === 'inside') {
            result = result.filter((o) => o.type === 'inside');
        } else if (params.type === 'takeaway') {
            result = result.filter((o) => o.type === 'takeaway');
        }
    }

    return result;
};

export default getFilteredOrders;
